module.exports = __webpack_public_path__ + "img/2x UHF-DVS-50 & 4x AE-150-M.8aa2c0d7.svg";